module.exports = __webpack_public_path__ + "img/elementwidths_jakp.c9a3552e.png";